import React from "react";
import { styled } from "@mui/material/styles";
import { CircularProgress } from "@mui/material";

const Wrapper = styled("div")(() => ({
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}));

export default function ComponentLoader() {
  return (
    <Wrapper>
      <CircularProgress color="secondary" />
    </Wrapper>
  );
}
